export default "__VITE_ASSET__aVDjdK5K__"